<template>
    <v-btn :disabled="disabled" class="v-btn">
        <div :class="spClass" class="btn">
            <div v-if="icon" class="icon-box">
                <icon v-if="!loading" :icon="icon" :height="iconHeight" :width="iconWidth"></icon>
                <div v-else class=" icon-loading"> </div>
            </div>
            <div v-if="text" :style="{'text-transform': textTransform}" class="text">{{ text }}<small v-if="smallText">&nbsp;{{ smallText }}</small></div>
        </div>
    </v-btn>
</template>

<script>

import Icon from '@/components/atoms/Icon'

export default {
    name: 'RegularButton',
    components: {
        Icon
    },
    props: {
        spClass: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: false
        },
        textTransform: {
            type: String,
            required: false
        },
        smallText: {
            type: String,
            required: false
        },
        iconWidth: {
            type: Number,
            required: false,
            default: 20
        },
        iconHeight: {
            type: Number,
            required: false,
            default: 20
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        type: {
            type: String,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
.btn {
    display: inline-flex;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
    .icon-box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-grow: 0;
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        color: $icon-primary;
        background-color: $primary;
        background-position: center;
    }

    .text {
        display: flex;
        flex-grow: 0;
        flex-shrink: 0;
        background-color: $secondary;
        color: $font;
        font-weight: 500;
        padding: 0 25px;
        align-items: center;
    }

    &.small {
        .text {
            padding: 0 20px;
        }
    }

    &.primary {
        .text {
            background-color: $primary-default;
            color: $font-default;
        }
    }

    &.gray {
        .text {
            background-color: $light-gray;
            color: $secondary-default;
        }
    }

    &.disabled,
    &.go-back {
        .icon {
            background-color: $primary;
        }
        .text {
            background-color: $light-gray;
            color: $dark;
        }
    }

    &.disabled--white {
        .icon {
            background-color: $inactive;
        }
        .text {
            background-color: $light-gray;
        }
    }

    &.no-padding-right {
        padding-right: 0;
    }

    &.no-padding-left {
        padding-left: 0;
    }

    .icon-loading {
        align-items: center;
        justify-content: center;

        &::after {
        content: '';
        display: block;
        width: 23px;
        height: 23px;
        border-radius: 50%;
        border: 3px solid rgba($inactive, 0.5);
        border-top: 3px solid $white;
        animation: spin 1s infinite;
        }
    }
}
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
